var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 291.69 291.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_13);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_13",
    "data-name": "Degradado sin nombre 13",
    x1: 145.84,
    y1: 0,
    x2: 145.84,
    y2: 291.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ac14b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06853a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 291.69,
    height: 291.69,
    rx: 48.19,
    ry: 48.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.29,143.29c0,53.5-43.71,96.88-97.63,96.88-17.12,0-33.21-4.37-47.2-12.05l-54.06,17.18,17.62-51.98c-8.89-14.6-14.01-31.73-14.01-50.03,0-53.51,43.71-96.89,97.64-96.89s97.63,43.38,97.63,96.89h0ZM147.66,61.83c-45.27,0-82.09,36.53-82.09,81.46,0,17.81,5.8,34.32,15.63,47.76l-10.25,30.25,31.54-10.02c12.96,8.5,28.49,13.47,45.17,13.47,45.26,0,82.08-36.54,82.08-81.45s-36.83-81.46-82.08-81.46h0ZM196.96,165.6c-.6-.99-2.2-1.59-4.59-2.77-2.39-1.19-14.17-6.94-16.36-7.72-2.19-.79-3.8-1.19-5.38,1.18-1.6,2.38-6.18,7.73-7.59,9.31-1.39,1.59-2.78,1.78-5.18.59-2.4-1.18-10.11-3.7-19.25-11.78-7.11-6.3-11.91-14.07-13.32-16.45-1.39-2.37-.14-3.66,1.05-4.84,1.08-1.07,2.4-2.77,3.59-4.15,1.2-1.39,1.6-2.39,2.39-3.97.8-1.59.4-2.97-.2-4.15-.59-1.19-5.38-12.87-7.38-17.63-1.98-4.75-3.98-4.57-5.38-4.57s-3.98.41-3.98.41c0,0-4.8.59-6.99,2.97-2.19,2.37-8.37,8.12-8.37,19.8s8.57,22.98,9.76,24.56c1.2,1.59,16.55,26.35,40.89,35.86,24.33,9.51,24.33,6.33,28.72,5.93,4.38-.39,14.16-5.74,16.15-11.29,2-5.55,2-10.3,1.4-11.29h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppLogo);
export default __webpack_public_path__ + "static/media/WhatsApp-logo.2e766b5baaac86717845f275326524ba.svg";
export { ForwardRef as ReactComponent };